<script setup lang="ts">
import {reactive, watchEffect, ref} from "vue";

useWreadiaSeo({
  title: "Aide",
});

const appUser = useAppUser();
const toast = useToast();

const state = reactive({
  email: "",
  message: "",
  token: "",
  loading: false,
});

watchEffect(() => {
  if (appUser.value?.email) {
    state.email = appUser.value.email;
  }
});

const turnstile = ref();

async function onSubmit() {
  state.loading = true;
  try {
    await $api("/api/feedbacks", {
      method: "POST",
      body: {
        email: state.email,
        message: state.message,
        token: state.token,
      },
    });

    toast.add({
      title: "Succès",
      description: "Ton message a bien été envoyé. Merci !",
      color: "success",
    });

    state.message = "";
  } catch (error: any) {
    toast.add({
      title: "Erreur",
      description: error.data?.message || "Une erreur est survenue lors de l'envoi du message.",
      color: "error",
    });
  } finally {
    turnstile.value?.reset();
    state.loading = false;
  }
}
</script>

<template>
  <UPage id="pagePage">
    <UPageBody id="pageBody">
      <UContainer>
        <h1 class="text-h2">Aide</h1>
        <p class="text-xl">Trouve une réponse, pose ta question, ou vote pour la suite de Wreadia.</p>
        <USeparator class="py-8"></USeparator>
        <div class="mb-8">
          <h2 class="text-h3">Tu cherches une réponse ?</h2>
          <p class="mb-4">On a déjà quelques réponses dans la FAQ.</p>
          <UButton to="/faq" color="secondary" variant="solid">Consulter la FAQ</UButton>
        </div>
        <div class="mb-8">
          <h2 class="text-h3">Tu as une question ou une remarque ?</h2>
          <p>Laisse ta question, un souci à signaler ou une idée d'amélioration. On te répond.</p>

          <UForm :state="state" @submit="onSubmit" class="mt-4 space-y-4 max-w-lg">
            <UFormField label="Ton email" name="email" required>
              <UInput v-model="state.email" type="email" placeholder="ton@email.com" class="w-full" :disabled="!!appUser"/>
            </UFormField>

            <UFormField label="Ton message" name="message" required>
              <UTextarea v-model="state.message" placeholder="Comment pouvons-nous t'aider ?" class="w-full" :rows="5"/>
            </UFormField>

            <NuxtTurnstile ref="turnstile" v-model="state.token"></NuxtTurnstile>

            <UButton type="submit" :loading="state.loading" color="primary" variant="solid">Envoyer</UButton>
          </UForm>
        </div>
        <div v-if="appUser" class="mb-8">
          <h2 class="text-h3">Quelle fonctionnalité aimerais-tu voir arriver ?</h2>
          <p class="mb-4">Vote pour les prochaines fonctionnalités. On construit Wreadia avec vous.</p>
          <UButton :to="userHasRole(appUser, 'author') ? `/dashboard/features`:`dashboard?tab=features`" color="secondary" variant="solid">Voter pour
            les fonctionnalités
          </UButton>
        </div>
      </UContainer>
    </UPageBody>
  </UPage>
</template>
